import React from 'react'
import './Cards.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {graphql} from 'gatsby'
import karnov from '../../assets/svg/icons/karnov.svg'
import innarbeid from '../../assets/svg/icons/ikon-innearbeid.svg'
import qrcode from '../../assets/pro-qr-code.png'

export default function Cards({title, text, mediaType, image, video, button, extraClasses}) {
	return(
		<div className={`Cards ${extraClasses ? extraClasses : ''}`}>
			<div className="Cards-media">
				{
					mediaType === 'image' && image && image.localFile && image.localFile.childImageSharp
					? <GatsbyImage className="media" image={getImage(image.localFile.childImageSharp)} alt={image.altText} />
					: mediaType === 'video' && video && video.localFile && video.localFile.publicURL
					? <video className="media" autoPlay muted loop playsInline>
						<source src={video.localFile.publicURL} type="video/mp4" />
					</video>
					: <div className="media" />
				}
			</div>
			<div className="Cards-text">
				{
					extraClasses &&
						<div>
							{
								extraClasses === 'right pencil' &&
								<img width="70" height="70" style={{marginBottom: 10}} src={innarbeid} alt="Innarbeid ikon" />
							}
						</div>
				}
				{ title && <h2>{title}</h2> }
				{ text && <p>{text}</p> }
				{
					extraClasses === 'karnov' &&
					<a href="https://www.karnovgroup.no/" target="_blank" rel="noreferrer">
						<img width="70" height="70" src={karnov} alt="Karnov logo" />
					</a>
				}
				{
					button &&
					<>
						<a href={button.url} target={button.target} className="Button primary"><span>{button.title}</span></a>
						<div className="qr-code">
							<p>Gå til mobilversjonen</p>
							<img width="150" src={qrcode} alt="QR code" />
						</div>
					</>
				}
			</div>
		</div>
	)
}

export const query = graphql`
	fragment Cards on WpPage_Layout_block_Layout_Cards {
		fieldGroupName
		title
		text
		mediaType
		extraClasses
		image {
			localFile {
				childImageSharp {
					gatsbyImageData
				}
			}
			altText
		}
		video {
			localFile {
				publicURL
			}
		}
		button {
			target
			title
			url
		}
	}
`;